// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__31TRS","colCheckbox":"styles_colCheckbox__108a4"};